import React from "react";
import WishlistButton from "./WishlistButton";
function furniture(){
    return <div className="furniture"> 
        
       
    <div className ="card">
    <div className="catalog-section-title"><h1>SofaSet</h1></div>
    <div className="row">

     <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/furnitureimages/Kurlon Photon Fabric 3 Seater Sofa.jpeg"} alt="" /></div>
   <div className="card-header"><h6>Kurlon Photon Fabric 3 Seater Sofa  </h6><p>Kurlon Photon Fabric 3 Seater Sofa  (Finish Color - NA)</p><h4> ₹16,834 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

     <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/furnitureimages/Bharat Lifestyle Gayana Leatherette 3 Seater Sofa.jpeg"}alt=""  /></div>
   <div className="card-header"><h6>Bharat Lifestyle Gayana Leatherette 3 Seater Sofa </h6><p>Bharat Lifestyle Gayana Leatherette 3 Seater Sofa  (Finish Color - Brown)</p><h4> ₹19,999 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

     <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/furnitureimages/Kurlon Photon Fabric 3Seater Sofa.jpeg"}alt=""  /></div>
   <div className="card-header"><h6>Kurlon Photon Fabric 3Seater Sofa </h6><p>Kurlon Photon Fabric 3 Seater Sofa  (Finish Color - Black)</p><h4> ₹16,311 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

      <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/furnitureimages/La-Z-Boy Dreamtime Fabric Manual Rocker Recliners Recliner.jpeg"} alt="" /></div>
   <div className="card-header"><h6>La-Z-Boy Dreamtime Fabric Manual Rocker Recliners Recliner</h6><p>La-Z-Boy Dreamtime Fabric Manual Rocker Recliners Recliner  (Finish Color - Beige)</p><h4> ₹35,390 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

     <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/furnitureimages/Nilkamal Fabric Manual Recliner.jpeg"}alt=""  /></div>
   <div className="card-header"><h6>Nilkamal Fabric Manual Recliner</h6><p>Nilkamal Fabric Manual Recliner  (Finish Color - Brown)</p><h4> ₹30,390 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

      <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/furnitureimages/Iris PVC 1 Seater Inflatable Sofa.jpeg"} alt="" /></div>
   <div className="card-header"><h6>Iris PVC 1 Seater Inflatable Sofa</h6><p>Iris PVC 1 Seater Inflatable Sofa  (Color - Purple)</p><h4> ₹4,999 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

      <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/furnitureimages/True Furniture Sheesham Wood 4 Seater Dining Table Set.jpeg"} alt="" /></div>
   <div className="card-header"><h6>True Furniture Sheesham Wood 4 Seater Dining Table Set</h6><p>True Furniture Sheesham Wood 4 Seater Dining Table Set with Chairs for Home (Honey Teak Brown) Solid Wood 4 Seater Dining Set  (Finish Color - Honey Teak Brown)</p><h4> ₹15,940 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

     <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/furnitureimages/SUNCROWN FURNITURE Sheesham Wood Solid Wood 6 Seater Dining Set.jpeg"}alt=""  /></div>
   <div className="card-header"><h6>SUNCROWN FURNITURE Sheesham Wood Solid Wood 6 Seater Dining Set</h6><p>SUNCROWN FURNITURE Sheesham Wood Solid Wood 6 Seater Dining Set  (Finish Color - Ash Finish)</p><h4> ₹31,918 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

      <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/furnitureimages/SUNCROWN FURNITURE Sheesham Wood Solid Wood 4 Seater Dining Set.jpeg"}alt=""  /></div>
   <div className="card-header"><h6>SUNCROWN FURNITURE Sheesham Wood Solid Wood 4 Seater Dining Set</h6><p>SUNCROWN FURNITURE Sheesham Wood Solid Wood 4 Seater Dining Set  (Finish Color - Teak Finish)</p><h4> ₹17,228 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>
    </div>
    </div>


     <div className ="card">
    <div className="catalog-section-title"><h1>Beds</h1></div>
    <div className="row">

      <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/furnitureimages/Flipkart Perfect Homes Waltz Engineered Wood King Box Bed.jpeg"} alt="" /></div>
   <div className="card-header"><h6>Flipkart Perfect Homes Waltz Engineered Wood King Box Bed </h6><p>Flipkart Perfect Homes Waltz Engineered Wood King Box Bed  (Finish Color - Wenge)</p><h4> ₹16,390 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

     <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/furnitureimages/home by Nilkamal Cipher Solid Wood Queen Bed.jpeg"} alt="" /></div>
   <div className="card-header"><h6>home by Nilkamal Cipher Solid Wood Queen Bed </h6><p>home by Nilkamal Cipher Solid Wood Queen Bed  (Finish Color - Espresso)</p><h4> ₹16,390 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

     <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/furnitureimages/Home Edge Sheesham Wood Solid Wood King Bed.jpeg"}alt=""  /></div>
   <div className="card-header"><h6>Home Edge Sheesham Wood Solid Wood King Bed</h6><p>Home Edge Sheesham Wood Solid Wood King Bed  (Finish Color - Teak)</p><h4> ₹20,499 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

      <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/furnitureimages/Perfect Homes Medley Engineered Wood Queen Hydraulic Bed.jpeg"}alt=""  /></div>
   <div className="card-header"><h6>Perfect Homes Medley Engineered Wood Queen Hydraulic Bed </h6><p>Perfect Homes Medley Engineered Wood Queen Hydraulic Bed  (Finish Color - Dark Wenge)</p><h4> ₹16,590 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

     <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/furnitureimages/Perfect Homes Opus Engineered Wood Queen Box Bed.jpeg"}alt="" /></div>
   <div className="card-header"><h6> Perfect Homes Opus Engineered Wood Queen Box Bed </h6><p>Perfect Homes Opus Engineered Wood Queen Box Bed  (Finish Color - Espresso)</p><h4> ₹11,790 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>

     <div className="pricing-column col-lg-4 col-md-6">
    <div className="card-body"><img src={process.env.PUBLIC_URL + "/images/furnitureimages/Perfect Homes Waltz Engineered Wood Queen Box Bed.jpeg"}alt=""  /></div>
   <div className="card-header"><h6>Perfect Homes Waltz Engineered Wood Queen Box Bed </h6><p>Flipkart Perfect Homes Waltz Engineered Wood Queen Box Bed  (Finish Color - Espresso)</p><h4> ₹13,290 </h4>
<button type="button" className="btn btn-danger">Add to Cart</button><WishlistButton />
<p><i class="fas fa-truck"></i> Free Shipping</p>
    </div>   
    </div>
    </div>
    </div>
  
  </div>
}

export default furniture;